export const PROCEED_EVENT_NAME = 'proceed'
export const LOAD_EVENT_NAME = 'load'
export const PAYMENT_REDIRECT_HASH: Record<string, string> = {
  CC: import.meta.env.VUE_APP_REDIRECT_PAYMENT_CC,
  DC: import.meta.env.VUE_APP_REDIRECT_PAYMENT_DC,
}

export const PAYMENT_METHOD_VALUE = {
  CC: 0,
  DC: 1,
  AP: 2,
  GP: 3,
}

export const PAYMENT_VALUE_TO_TYPE: Record<number, string> = {
  0: 'CC',
  1: 'DC',
  2: 'AP',
  3: 'GP',
}
